import { Action } from '@ngrx/store';
import {Evaluacion} from '../../docente/evaluacion';

/*
* Cargar evaluaciones
* */
export const CARGAR_EVALUACIONES = '[EVALUACION] Cargar Evaluaciones';
export const CARGAR_EVALUACIONES_FAIL = '[EVALUACION] Cargar Evaluaciones FAIL';
export const CARGAR_EVALUACIONES_SUCCESS = '[EVALUACION] Cargar Evaluaciones SUCCESS';


export class CargarEvaluaciones implements Action {
  readonly type = CARGAR_EVALUACIONES;
}
export class CargarEvaluacionesFail implements Action {
  readonly type = CARGAR_EVALUACIONES_FAIL;
  constructor(public payload: any) {}
}
export class CargarEvaluacionesSuccess implements Action {
  readonly type = CARGAR_EVALUACIONES_SUCCESS;
  constructor(public evaluaciones: Evaluacion[]) {}
}

/*
* Cargar evaluaciones por grupo
* */
export const CARGAR_EVALUACIONES_GRUPO = '[EVALUACION] Cargar Evaluaciones por Grupo';
export const CARGAR_EVALUACIONES_GRUPO_FAIL = '[EVALUACION] Cargar Evaluaciones por Grupo FAIL';
export const CARGAR_EVALUACIONES_GRUPO_SUCCESS = '[EVALUACION] Cargar Evaluaciones por Grupo SUCCESS';


export class CargarEvaluacionesGrupo implements Action {
  readonly type = CARGAR_EVALUACIONES_GRUPO;
  constructor(public grupoId: number) {}
}
export class CargarEvaluacionesGrupoFail implements Action {
  readonly type = CARGAR_EVALUACIONES_GRUPO_FAIL;
  constructor(public payload: any) {}
}
export class CargarEvaluacionesGrupoSuccess implements Action {
  readonly type = CARGAR_EVALUACIONES_GRUPO_SUCCESS;
  constructor(public evaluaciones: Evaluacion[]) {}
}


/*
* Guardar Evaluacion
* */

export const GUARDAR_EVALUACION = '[Evaluacion] Guardar evaluacion';
export const GUARDAR_EVALUACION_FAIL = '[Evaluacion] Guardar evaluacion FAIL';
export const GUARDAR_EVALUACION_SUCCESS = '[Evaluacion] Guardar evaluacion SUCCESS';

export class GuardarEvaluacion implements Action {
  readonly type = GUARDAR_EVALUACION;
  constructor(public evaluacion: Evaluacion) {}
}
export class GuardarEvaluacionFail implements Action {
  readonly type = GUARDAR_EVALUACION_FAIL;
  constructor(public payload: any) {}
}
export class GuardarEvaluacionSuccess implements Action {
  readonly type = GUARDAR_EVALUACION_SUCCESS;
  constructor(public evaluacion: Evaluacion) {}
}

/*
* Editar Evaluacion
* */

export const ACTUALIZAR_EVALUACION = '[Evaluacion] Actualizar evaluacion';
export const ACTUALIZAR_EVALUACION_FAIL = '[Evaluacion] Actualizar evaluacion FAIL';
export const ACTUALIZAR_EVALUACION_SUCCESS = '[Evaluacion] Actualizar evaluacion SUCCESS';

export class ActualizarEvaluacion implements Action {
  readonly type = ACTUALIZAR_EVALUACION;
  constructor(public evaluacion: Evaluacion, public evaluacionId: number) {}
}
export class ActualizarEvaluacionFail implements Action {
  readonly type = ACTUALIZAR_EVALUACION_FAIL;
  constructor(public payload: any) {}
}
export class ActualizarEvaluacionSuccess implements Action {
  readonly type = ACTUALIZAR_EVALUACION_SUCCESS;
  constructor(public evaluacion: Evaluacion, public evaluacionId: number) {}
}

/*Eliminar Evaluacion*/

export const ELIMINAR_EVALUACION = '[Evaluacion] Eliminar evaluacion';
export const ELIMINAR_EVALUACION_FAIL = '[Evaluacion] Eliminar evaluacion FAIL';
export const ELIMINAR_EVALUACION_SUCCESS = '[Evaluacion] Eliminar evaluacion SUCCESS';

export class EliminarEvaluacion implements Action {
  readonly type = ELIMINAR_EVALUACION;
  constructor(public evaluacionId: number) {}
}
export class EliminarEvaluacionFail implements Action {
  readonly type = ELIMINAR_EVALUACION_FAIL;
  constructor(public payload: any) {}
}
export class EliminarEvaluacionSuccess implements Action {
  readonly type = ELIMINAR_EVALUACION_SUCCESS;
  constructor(public evaluacionId: number) {}
}


export type evaluacionesAcciones =  CargarEvaluacionesGrupo |
                                    CargarEvaluacionesGrupoFail |
                                    CargarEvaluacionesGrupoSuccess |
                                    CargarEvaluaciones |
                                    CargarEvaluacionesFail |
                                    CargarEvaluacionesSuccess |
                                    GuardarEvaluacion |
                                    GuardarEvaluacionFail |
                                    GuardarEvaluacionSuccess |
                                    ActualizarEvaluacion |
                                    ActualizarEvaluacionFail |
                                    ActualizarEvaluacionSuccess |
                                    EliminarEvaluacion |
                                    EliminarEvaluacionFail |
                                    EliminarEvaluacionSuccess;
